import React from "react";
import Summary from "../../../../components/cases/assets/balanceOfAssets/sonstiges/Summary";

const Sonstiges = ({ next, back, tabText }) => {
  return (
    <>
      <Summary next={next} back={back} />{" "}
      {/* <SuggestionBox mainText={tabText} setVisited={visited} /> */}
    </>
  );
};

export default Sonstiges;
